// extracted by mini-css-extract-plugin
module.exports = {"details":"SurveyDetails_details__1JaVs","surveydetails":"SurveyDetails_surveydetails__QC8G1","mailbody":"SurveyDetails_mailbody__3YFzc"};